import { redirect, createFileRoute } from '@tanstack/react-router'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/postal-request-code')({
  beforeLoad: async ({ location, search }) => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      search.amoe = 'postal-request-code'
      return redirect({ to: '/', search })
    }

    const targetUrl = window.location.origin + location.href

    await oidc.login({
      redirectUrl: targetUrl,
      doesCurrentHrefRequiresAuth: window.location.href === targetUrl,
    })
  },
})
